
import "bootstrap/dist/css/bootstrap.min.css";
import { FaArrowRight } from "react-icons/fa";
import aboutImg from "../images/acfan.jpg";
import swastik from "../images/swastik.png"
import React, { useState, useEffect } from "react";
import { URL } from "../Redux/common/url";
function AboutSection() {
  const [productLists, setProductLists] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProductList();
  }, []);

  const fetchProductList = async () => {
    try {
      const response = await fetch(`${URL.API_BASE_URL}/publicApi/aboutnewListPublic`);
      if (!response.ok) throw new Error("Network response was not ok");
      const data = await response.json();
      setProductLists(data?.aboutnew || []);
      setLoading(false);
    } catch (error) {
      console.error("Fetch error:", error);
      setLoading(false);
    }
  };

  if (loading) return <p className="text-center py-5">Loading...</p>;
  return (
    
    <div className="container-fluid mt-5">
          {productLists.map((item, index) => (
      <div className="row align-items-center mb-4">
        {/* Left Side Image with 18+ Years Box */}
      
        <div className="col-md-6 position-relative">
          <img
             src={URL?.API_BASE_URL + item?.feature_image}
                    alt={item.title}
            className="shadow w-100 product-img-out"
          />
          <div className="years-box position-absolute top-50 start-0 translate-middle-y rounded-end-3 text-center fw-bold">
            <span className="d-block fs-3">25+</span>
            <small className="text-uppercase">Years Of</small>
            <br />
            <small className="text-uppercase">Experiences</small>
          </div>
        </div>

        {/* Right Side Content */}
        <div className="col-md-6" style={{ color: '#00b725'}}>
          <h1 className=" fw-bold">{item.title}</h1>
          <div className="divider" style={{ borderColor: '#00b725'}} />
          <h2 className="fw-bold " style={{ color: '#00b725'}}>{item.subheading}</h2>
          <p className="text-muted">
           {item.short_description}
          </p>

          <ul className="list-unstyled">
            <li className="mb-2">
              <FaArrowRight className=" me-2" style={{ color: '#00b725'}} />
              <span>
                {/* <img className="w-100 me-1" src={swastik} alt="" style={{ maxWidth: "20px" }} /> */}
                <span className="pt-2">{item.subheading_one}</span>
              </span>
            </li>

            <li className="mb-2">
              <FaArrowRight className=" me-2" style={{ color: '#00b725'}} />
              <span>
                {/* <img className="w-100 me-1" src={swastik} alt="" style={{ maxWidth: "20px" }} /> */}
                <span className="pt-2">{item.subheading_two}</span>
              </span>
            </li>

            <li className="mb-2">
              <FaArrowRight className=" me-2" style={{ color: '#00b725'}} />
              <span>
                {/* <img className="w-100 me-1" src={swastik} alt="" style={{ maxWidth: "20px" }} /> */}
                <span className="pt-2">{item.subheading_three}</span>
              </span>
            </li>

            {/* <li className="mb-2">
              <FaArrowRight className="text-danger me-2" />
              <span>
                <img className="w-100 me-1" src={swastik} alt="" style={{ maxWidth: "20px" }} />
                <span className="pt-2">Trusted by leading corporates & government organizations.</span>
              </span>
            </li> */}
          </ul>

          <div className="divider" style={{ borderColor: '#00b725'}} />

          <button className="btn mt-3" style={{ backgroundColor: '#00b725', border: 'none' }}>
       <a href="/company" style={{ color: "#fff", textDecoration: "none" }}>
            MORE <FaArrowRight className="ms-2" />
         </a>
          </button>
        </div>
      </div>
        ))}
    </div>
  );
}

export default AboutSection;
